import { SaleOrder, type SaleOrderData } from './SaleOrder';

export interface PendingSaleOrderData {
  isPayable: boolean;
  paymentUrl?: string;
}

export class PendingSaleOrder extends SaleOrder {
  isPayable;
  paymentUrl;

  constructor(data: SaleOrderData, pendingData: PendingSaleOrderData) {
    super(data);

    this.isPayable = pendingData.isPayable;
    this.paymentUrl = pendingData.paymentUrl;
  }
}
